<template>
  <AppSection
    id="monitoring-jobs"
    type="section"
    :title="$t($getConst.pages.connectivity_test.failed_jobs_launched)"
  >
    <AppDataTable
      ref="failedTable"
      :fields="fields"
      :end-point="endPoint"
    >
      <template v-slot:status="item">
        <b-badge variant="warning" v-if="item.row.status === 'pending'">
          {{ $t($getConst.pages.connectivity_test.pending) }}
        </b-badge>
        <b-badge variant="danger" v-else-if="item.row.status === 'failed'">
          {{ $t($getConst.pages.connectivity_test.failed) }}
        </b-badge>
        <b-badge variant="success" v-else-if="item.row.status === 'succeed'">
          {{ $t($getConst.pages.connectivity_test.succeed) }}
        </b-badge>
      </template>

      <template v-slot:payload="item">
        #job-{{ item.row.id }} : {{ item.data.displayName }} ...
        <b-link @click="showPayloadDetails(item.row)" v-b-tooltip.hover
                :title="$t($getConst.pages.button.show_more)"><i
          :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

      <template v-slot:exception="item">
        {{ item.data.substr(0, 14) }} ...
        <b-link @click="showExceptionDetails(item.row)" v-b-tooltip.hover
                :title="$t($getConst.pages.button.show_more)"><i
          :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

    </AppDataTable>
    <ShowPayloadDetailsModal v-if="job" :id="payloadDetailsModal" :job="job" size="xl"/>
    <ShowExceptionDetailsModal v-if="job" :id="exceptionDetailsModal" :job="job" size="xl"/>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../components/common/table/AppDataTable";
  import ShowPayloadDetailsModal from "./ShowPayloadDetailsModal";
  import ShowExceptionDetailsModal from "./ShowExceptionDetailsModal";

  export default {
    name: "failedJobsLaunched",
    components: {ShowExceptionDetailsModal, ShowPayloadDetailsModal, AppDataTable, AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        endPoint: null,
        fields: [
          {key: 'user', sortable: false, filterable: true},
          {key: 'job_type', sortable: false, filterable: true},
          {key: 'template_type', sortable: false, filterable: true},
          {key: 'status', sortable: false, filterable: true},
          {key: 'payload', sortable: false, filterable: false},
          {key: 'exception', sortable: false, filterable: false},
          {key: 'failed_at', sortable: false, filterable: 'date'},
          {key: 'created_at', sortable: false, filterable: 'date'},
        ],
        payloadDetailsModal: 'show-payload-details-modal',
        exceptionDetailsModal: 'show-exception-details-modal',
        job: null
      }
    },
    methods: {
      showPayloadDetails(job) {
        this.job = job;
        this.$nextTick(() => this.$bvModal.show(this.payloadDetailsModal));
      },
      showExceptionDetails(job) {
        this.job = job;
        this.$nextTick(() => this.$bvModal.show(this.exceptionDetailsModal));
      },
    },
    created() {
      this.endPoint = '/scopes/' + this.scope_id + '/failed_jobs_launched';
      this.fields[3].filterable = [
          { value: 'pending', text: 'pending' },
          { value: 'failed', text: 'failed' },
          { value: 'succeed', text: 'succeed' },
       ];
    },
  }
</script>

<style scoped>

</style>
